import { TenantRelationAssignment } from '@shared/models/tenant-relation-assignment';

/** Relation type ids the guest already has active (excluding the booking's own assignment in edit mode). */
export function duplicateRelationIdsFromAssignments(
    assignments: readonly TenantRelationAssignment[],
    ownAssignmentId: number | null = null,
): ReadonlySet<number> {
    const ids = new Set<number>();
    for (const assignment of assignments) {
        if (ownAssignmentId != null && assignment.id === ownAssignmentId) {
            continue;
        }
        const relationId = assignment.tenantRelation?.id;
        if (relationId != null) {
            ids.add(relationId);
        }
    }
    return ids;
}
